export interface INavbarData {
  routeLink: string;
  routeLinkSecondary?: string[];
  icon?: string;
  label: string;
  roles?: any;
  permissions: any;
  expanded?: boolean;
  childs?: INavbarData[];
}

export const menuItemsData: INavbarData[] = [
  {
    label: 'MENUITEMS.DASHBOARDS.TEXT',
    icon: 'house',
    routeLink: '/dashboard',
    roles: [],
    permissions: [],
  },
  // System Settings
  {
    label: 'MENUITEMS.SystemSettings.TEXT',
    icon: 'settings',
    routeLink: '/system',
    routeLinkSecondary: ['/oracle-pridge/system/'],
    roles: ['SuperAdmin'],
    permissions: [
      'Category.View',
      'Category.Create',
      'Brand.View',
      'Brand.Create',
      'Product.View',
      'Product.Create',
      'Product.View',
      'Product.Create',
      'Offer.View',
      'Offer.Create',
      'Notification.View',
      'Notification.Create',
      'Coupon.View',
      'Coupon.Create',
      'Policy.View',
      'Policy.Create',
    ],
    childs: [
      {
        label: 'MENUITEMS.SystemSettings.CategoriesSettings.TEXT',
        icon: 'dot',
        routeLink: '/system/category/categories-settings',
        roles: ['SuperAdmin'],
        permissions: ['Category.View', 'Category.Create']
      },

      {
        label: 'MENUITEMS.SystemSettings.BrandsSettings.TEXT',
        icon: 'dot',
        routeLink: '/system/brands/brands-settings',
        roles: ['SuperAdmin'],
        permissions: ['Brand.View', 'Brand.Create']
      },

      {
        label: 'MENUITEMS.SystemSettings.ProductsSettings.TEXT',
        icon: 'dot',
        routeLink: '/system/products/products-settings',
        roles: ['SuperAdmin'],
        permissions: ['Product.View', 'Product.Create']
      },

      {
        label: 'MENUITEMS.SystemSettings.CashbackProducts.TEXT',
        icon: 'dot',
        routeLink: '/system/products/cashback-products',
        roles: ['SuperAdmin'],
        permissions: ['Product.View', 'Product.Create']
      },

      {
        label: 'MENUITEMS.SystemSettings.OffersSettings.TEXT',
        icon: 'dot',
        routeLink: '/system/offers/offers-settings',
        roles: ['SuperAdmin'],
        permissions: ['Offer.View', 'Offer.Create']
      },

      {
        label: 'MENUITEMS.SystemSettings.NotificationsSettings.TEXT',
        icon: 'dot',
        routeLink: '/system/notifications/notification-settings',
        roles: ['SuperAdmin'],
        permissions: ['Notification.View', 'Notification.Create']
      },

      {
        label: 'MENUITEMS.SystemSettings.WhatsappMessages.TEXT',
        icon: 'dot',
        routeLink: '/system/whatsapp-messages',
        roles: ['SuperAdmin'],
        permissions: []
      },

      {
        label: 'MENUITEMS.SystemSettings.CouponsSettings.TEXT',
        icon: 'dot',
        routeLink: '/system/coupons/coupons-settings',
        roles: ['SuperAdmin'],
        permissions: ['Coupon.View', 'Coupon.Create']
      },

      {
        label: 'MENUITEMS.SystemSettings.RolesSettings.TEXT',
        icon: 'dot',
        routeLink: '/system/roles/roles-settings',
        roles: ['SuperAdmin'],
        permissions: []
      },

      {
        label: 'MENUITEMS.SystemSettings.VersionsSettings.TEXT',
        icon: 'dot',
        routeLink: '/system/versions/versions-settings',
        roles: ['SuperAdmin'],
        permissions: []
      },

      {
        label: 'MENUITEMS.SystemSettings.ProvidersSettings.TEXT',
        icon: 'dot',
        routeLink: '/system/providers/providers-settings',
        roles: ['SuperAdmin'],
        permissions: []
      },
      {
        label: 'MENUITEMS.SystemSettings.PolicySettings.TEXT',
        icon: 'dot',
        routeLink: '/system/policy/policy-settings',
        roles: ['SuperAdmin'],
        permissions: ['Policy.View', 'Policy.Create']
      },

      {
        label: 'MENUITEMS.SystemSettings.SendBulkSms.TEXT',
        icon: 'dot',
        routeLink: '/system/sms/send-bulk-sms',
        roles: ['SuperAdmin'],
        permissions: []
      },
      {
        label: 'MENUITEMS.SystemSettings.GenerateBills.TEXT',
        icon: 'dot',
        routeLink: '/oracle-pridge/system/generate-bills',
        roles: ['SuperAdmin'],
        permissions: []
      },
      {
        label: 'MENUITEMS.SystemSettings.SendBills.TEXT',
        icon: 'dot',
        routeLink: '/oracle-pridge/system/send-bills',
        roles: ['SuperAdmin'],
        permissions: []
      },
    ]
  },
  // Wholesale
  {
    label: 'MENUITEMS.Wholesale.TEXT',
    icon: 'settings',
    routeLink: '/wholesale',
    roles: [],
    permissions: [
      'Wholesale.View',
      'Wholesale.Create'
    ],
    childs: [
      {
        label: 'MENUITEMS.Wholesale.GetBills',
        icon: 'dot',
        routeLink: '/wholesale/get-wholesale-bill',
        roles: [],
        permissions: ['Wholesale.View']
      },
      {
        label: 'MENUITEMS.Wholesale.CreateBills',
        icon: 'dot',
        routeLink: '/wholesale/create-wholesale-bill',
        roles: [],
        permissions: ['Wholesale.Create']
      },
      {
        label: 'MENUITEMS.SystemSettings.WholesaleCustomersSettings.TEXT',
        icon: 'dot',
        routeLink: '/wholesale/wholesale-customers',
        roles: [],
        permissions: ['WholesaleCustomer.View']
      },
      {
        label: 'MENUITEMS.SystemSettings.SendBillsWholeSale.TEXT',
        icon: 'dot',
        routeLink: '/oracle-pridge/system/send-wholesale-bills',
        roles: ['SuperAdmin'],
        permissions: []
      },
    ]
  },
  // Settings
  {
    label: 'MENUITEMS.Settings.TEXT',
    icon: 'settings',
    routeLink: '/settings',
    roles: ['SuperAdmin'],
    permissions: [],
    childs:[
      {
        label: 'MENUITEMS.Settings.ActionSettings.TEXT',
        icon: 'dot',
        routeLink: '/settings/action-settings',
        roles: ['SuperAdmin'],
        permissions: []
      },
      {
        label: 'MENUITEMS.Settings.GeneralSettings.TEXT',
        icon: 'dot',
        routeLink: '/settings/general-settings',
        roles: ['SuperAdmin'],
        permissions: []
      },
    ]
  },

  //User Management
  {
    label: 'MENUITEMS.UsersManagement.TEXT',
    icon: 'user',
    routeLink: '/users',
    roles: [],
    permissions: [
      'Customer.View',
      'Group.View',
      'Group.Create'
    ],
    childs: [
      {
        label: 'MENUITEMS.SystemSettings.RegisterUsers.TEXT',
        icon: 'dot',
        routeLink: 'users/register',
        roles: ['SuperAdmin'],
        permissions: []
      },

      {
        label: 'MENUITEMS.SystemSettings.UsersSettings.TEXT',
        icon: 'dot',
        routeLink: 'users/users-settings',
        roles: ['SuperAdmin', 'Accountants'],
        permissions: []
      },

      {
        label: 'MENUITEMS.SystemSettings.CustomersAccounts.TEXT',
        icon: 'dot',
        routeLink: 'users/customers/customer-accounts',
        roles: ['SuperAdmin', 'Accountants', 'CustomerBalance'],
        permissions: ['Customer.View']
      },

      {
        label: 'MENUITEMS.SystemSettings.CustomerGroups.TEXT',
        icon: 'dot',
        routeLink: 'users/customers/customer-groups',
        roles: ['SuperAdmin'],
        permissions: ['Group.View', 'Group.Create']
      },

    ]
  },

  //Compensation
  {
    label: 'MENUITEMS.Compensation.TEXT',
    icon: 'hand-coins',
    routeLink: '/compensation',
    roles: [],
    permissions: [
      'Report.SalesBank'
    ],
    childs: [
      {
        label: 'MENUITEMS.Compensation.BalanceCharge',
        icon: 'dot',
        routeLink: 'compensation/balance-charge',
        roles: ['SuperAdmin'],
        permissions: []
      },

      {
        label: 'MENUITEMS.Compensation.MadaDirectSale',
        icon: 'dot',
        routeLink: 'compensation/mada-direct-sell',
        roles: [],
        permissions: ['Report.SalesBank']
      },
    ]
  },

  // Prices Settings
  {
    label: 'MENUITEMS.PricesSettings.TEXT',
    routeLink: '/prices/',
    icon: 'coins',
    roles: [
      'SuperAdmin', 'Distributor'
    ],
    permissions: [
      'Prices.Create',
      'Prices.View'
    ],
    childs: [
      {
        label: 'MENUITEMS.PricesSettings.AddUpdatePrice.TEXT',
        icon: 'dot',
        routeLink: '/prices/add-update-prices',
        roles: ['SuperAdmin', 'Distributor'],
        permissions: ['Prices.Create']
      },
      {
        label: 'MENUITEMS.PricesSettings.AddUpdatePrice.Admin',
        icon: 'dot',
        routeLink: '/prices/admin-add-update-prices',
        roles: ['SuperAdmin'],
        permissions: ['Prices.Create']
      },
      {
        label: 'MENUITEMS.PricesSettings.ViewCopyPrice.TEXT',
        icon: 'dot',
        routeLink: '/prices/view-copy-prices',
        roles: ['SuperAdmin', 'Distributor'],
        permissions: ['Prices.View']
      },
      {
        label: 'MENUITEMS.PricesSettings.ViewCopyPrice.Admin',
        icon: 'dot',
        routeLink: '/prices/admin-view-copy-prices',
        roles: ['SuperAdmin'],
        permissions: ['Prices.View']
      },
    ]
  },

   // Distributors
   {
    label: 'MENUITEMS.Distributors.TEXT',
    icon: 'user',
    routeLink: '/distributors',
    roles: ['Agent', 'Distributor'],
    permissions: [],
    childs: [
      {
        label: 'MENUITEMS.Distributors.Dashboard.TEXT',
        icon: 'dot',
        routeLink: '/distributors/customer-accounts',
        roles: ['Agent', 'Distributor'],
        permissions: []
      },
    ]
  },

  // Sadad Request (Finance)
  {
    label: 'MENUITEMS.SADAD.TEXT',
    routeLink: '/finance',
    icon: 'landmark',
    roles: ['SuperAdmin', 'Agent', 'Accountants', 'CustomerBalance'],
    permissions: ['Customer.View','UserBalance.Update','UserBalance.View'],
    childs: [
      {
        label: 'MENUITEMS.SystemSettings.CustomersBalanceTransaction.TEXT',
        icon: 'dot',
        routeLink: '/finance/customer-balance-transactions',
        roles: ['SuperAdmin', 'Agent', 'Accountants', 'CustomerBalance'],
        permissions: ['Customer.View']
      },
      {
        label: 'MENUITEMS.SystemSettings.CustomersBalanceTransactionNotAdmin.TEXT',
        icon: 'dot',
        routeLink: '/finance/customer-transfers',
        roles: ['SuperAdmin', 'Agent', 'Accountants', 'CustomerBalance'],
        permissions: ['Customer.View']
      },
      {
        label: 'MENUITEMS.SADAD.ProfitTransfer.TEXT',
        icon: 'dot',
        routeLink: '/finance/profit-transfer',
        roles: ['SuperAdmin','Accountants'],
        permissions: ['UserBalance.Update']
      },
      {
        label: 'MENUITEMS.SADAD.ProfitHistory.TEXT',
        icon: 'dot',
        routeLink: '/finance/profit-history',
        roles: ['SuperAdmin','Accountants'],
        permissions: ['UserBalance.View']
      },
    ]
  },

  // Pos
  {
    label: 'MENUITEMS.Pos.TEXT',
    icon: 'smartphone',
    routeLink: '/pos/',
    roles: ['SuperAdmin', 'POSAdmin', 'Accountants'],
    permissions: [],
    childs: [
      {
        label: 'MENUITEMS.Pos.ViewPos.TEXT',
        icon: 'dot',
        routeLink: '/pos/pos-inventory',
        roles: ['SuperAdmin', 'POSAdmin', 'Accountants'],
        permissions: []
      },
      {
        label: 'MENUITEMS.Pos.BlockedPos.TEXT',
        icon: 'dot',
        routeLink: '/pos/blocked-pos',
        roles: ['SuperAdmin', 'POSAdmin', 'Accountants'],
        permissions: []
      },
      {
        label: 'MENUITEMS.Pos.Captains.TEXT',
        icon: 'dot',
        routeLink: '/pos/captains',
        roles: ['SuperAdmin', 'POSAdmin', 'Accountants'],
        permissions: []
      },
    ]
  },

  // Cards
  {
    label: 'MENUITEMS.CARDS.TEXT',
    icon: 'wallet-cards',
    routeLink:'/invoice',
    roles: [],
    permissions: ['Invoice.Create','Invoice.Approval','Report.CardInfo','Report.PosTransactionLogs'],
    childs: [
      {
        label: 'MENUITEMS.CARDS.AddCard.TEXT',
        icon: 'dot',
        routeLink: '/invoice/manage-cards-invoice',
        roles: ['SuperAdmin'],
        permissions: ['Invoice.Create']
      },
      {
        label: 'Csv files',
        icon: 'dot',
        routeLink: '/invoice/manage-cards-csv',
        roles: ['SuperAdmin'],
        permissions: ['Invoice.Create']
      },
      {
        label: 'Excel files',
        icon: 'dot',
        routeLink: '/invoice/manage-cards-excel',
        roles: ['SuperAdmin'],
        permissions: ['Invoice.Create']
      },
      {
        label: 'MENUITEMS.CARDS.ApproveCard.TEXT',
        icon: 'dot',
        routeLink: '/invoice/approve-cards-invoice',
        roles: ['SuperAdmin', 'Accountants'],
        permissions: ['Invoice.Approval']
      },
      {
        label: 'MENUITEMS.CARDS.SearchCard.TEXT',
        icon: 'dot',
        routeLink: '/invoice/search-cards-invoice',
        roles: ['SuperAdmin'],
        permissions: ['Report.CardInfo']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportInitialBalance.Text',
        icon: 'dot',
        routeLink: '/invoice/report-initial-balance',
        roles: [],
        permissions: ['Report.PosTransactionLogs']
      },

    ]
  },

  // Reports
  {
    label: 'MENUITEMS.REPORTS.TEXT',
    icon:'file-text',
    routeLink: '/report/',
    routeLinkSecondary:['/oracle-pridge/report/'],
    roles: ['SuperAdmin', 'Accountants' , 'SalesManger','Ziad'],
    permissions: [
      'Report.WholeSale',
      'Report.Purchase',
      'Report.Bills',
      'Report.Transactions',
      'Report.DonePayments',
      'Report.WholePurchase',
      'Report.WholeSales',
      'Report.WholeSalesZain',
      'Report.WholeAvailableZain',
      'Report.WholeAvailable',
      'Ticket.View',
      'Report.ZeroBalance',
      'Report.JoinSupport',
      'Report.Target',
      'Report.SalesBank',
      'Report.PosTransactionLogs',
      'Report.GetTransactionLogs'
    ],
    childs: [
      {
        label: 'MENUITEMS.REPORTS.ReportManager.Text',
        icon:'dot',
        routeLink: '/report/report-manager',
        roles: [],
        permissions: ['Report.WholeSale']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportCardInvoice.Text',
        icon:'dot',
        routeLink: '/report/report-cards-invoice',
        roles: [],
        permissions: ['Report.Purchase']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportBills.Text',
        icon:'dot',
        routeLink: '/report/report-bills',
        roles: [],
        permissions: ['Report.Bills']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportTransactions.Text',
        icon:'dot',
        routeLink: '/report/transaction-report',
        roles: [],
        permissions: ['Report.Transactions']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportPayments.Text',
        icon:'dot',
        routeLink: '/report/payments-report',
        roles: [],
        permissions: ['Report.DonePayments']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportPurchase.Text',
        icon:'dot',
        routeLink: '/report/purchase-report',
        roles: [],
        permissions: ['Report.WholePurchase']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportSales.Text',
        icon:'dot',
        routeLink: '/report/sales-report',
        roles: [],
        permissions: ['Report.WholeSales']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportSaleszain.Text',
        icon:'dot',
        routeLink: '/report/sales-zain-report',
        roles: [],
        permissions: ['Report.WholeSalesZain']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportAvailable.Text',
        icon:'dot',
        routeLink: '/report/available-report',
        roles: [],
        permissions: ['Report.WholeAvailable']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportAvailablezain.Text',
        icon:'dot',
        routeLink: '/report/zain-available-report',
        roles: [],
        permissions: ['Report.WholeAvailableZain']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportAvailableExpiration.Text',
        icon:'dot',
        routeLink: '/report/expiration-available-report',
        roles: [],
        permissions: ['Report.WholeAvailable']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportTickets.Text',
        icon:'dot',
        routeLink: '/report/tickets-report',
        roles: [],
        permissions: ['Ticket.View']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportZeroBalance.Text',
        icon:'dot',
        routeLink: '/report/reports-zero-balance',
        roles: [],
        permissions: ['Report.ZeroBalance']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportJoinSupport.Text',
        icon:'dot',
        routeLink: '/report/join-and-support-report',
        roles: [],
        permissions: ['Report.JoinSupport']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportTarget.Text',
        icon:'dot',
        routeLink: '/report/target-report',
        roles: ['SuperAdmin', 'Accountants','SalesManger','Ziad'],
        permissions: ['Report.Target']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportTargetMonthly.Text',
        icon:'dot',
        routeLink: '/report/monthly-target-report',
        roles: [],
        permissions: ['Report.SalesBank']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportSalesBank.Text',
        icon:'dot',
        routeLink: '/report/wholesale-bankcommision',
        roles: [],
        permissions: ['Report.SalesBank']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportPosTransactionLogs.Text',
        icon:'dot',
        routeLink: '/report/pos-transaction-logs',
        roles: [],
        permissions: ['Report.PosTransactionLogs']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportNeoLeapTransaction.Text',
        icon:'dot',
        routeLink: '/report/neoleap-transaction-report',
        roles: [],
        permissions: ['Report.PosTransactionLogs']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportPosTransactionLogsPrint.Text',
        icon:'dot',
        routeLink: '/report/print-pos-transaction-logs',
        roles: [],
        permissions: ['Report.PosTransactionLogs']
      },
       {
        label: 'MENUITEMS.REPORTS.ReportNeoLeapTransactionPrint.Text',
        icon:'dot',
        routeLink: '/report/print-neoleap-transaction-report',
        roles: [],
        permissions: ['Report.PosTransactionLogs']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportEBill.Text',
        icon:'dot',
        routeLink: '/oracle-pridge/report/e-bill',
        roles: ['SuperAdmin'],
        permissions: []
      },
      {
        label: 'MENUITEMS.REPORTS.ReportTransactionLogsAdmin.Text',
        icon:'dot',
        routeLink: '/report/transaction-logs-admin',
        roles: ['SuperAdmin'],
        permissions: ['Report.GetTransactionLogs']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportOrcale.Text',
        icon:'dot',
        routeLink: '/report/oracle-report',
        roles: ['SuperAdmin'],
        permissions: ['Report.GetTransactionLogs']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportPriceDifference.Text',
        icon:'dot',
        routeLink: '/report/price-difference',
        roles: [],
        permissions: ['Report.GetTransactionLogs']
      },
      {
        label: 'MENUITEMS.REPORTS.ReportMadaTotalAgent.Text',
        icon:'dot',
        routeLink: '/report/mada-total-agent',
        roles: ['SuperAdmin'],
        permissions: []
      },
      {
        label: 'MENUITEMS.REPORTS.OpeningBalanceAll.Text',
        icon:'dot',
        routeLink: '/report/opening-balance-all',
        roles: [],
        permissions: ['Report.ZeroBalance']
      },
      {
        label: 'MENUITEMS.REPORTS.transactionTotal.Text',
        icon:'dot',
        routeLink: '/report/transaction-all-report',
        roles: [],
        permissions: ['Report.Transactions']
      },
      {
        label: 'MENUITEMS.REPORTS.getPinsSell.Text',
        icon:'dot',
        routeLink: '/report/get-pins-sell',
        roles: ['SuperAdmin', 'Accountants' , 'SalesManger'],
        permissions: []
      },

    ]
  },
  // Managment Reports
  {
    label: 'MENUITEMS.ManagmentReports.TEXT',
    routeLink: '/managment-report/',
    icon: 'file-pen-line',
    roles: ['SuperAdmin'],
    permissions: ['Report.Target'],
    childs: [
      {
        label: 'MENUITEMS.ManagmentReports.ReportTargetAll.Text',
        icon:'dot',
        routeLink: '/managment-report/target-report-all',
        roles: ['SuperAdmin'],
        permissions: ['Report.Target']
      },
      // {
      //   label: 'MENUITEMS.ManagmentReports.ReportTargetManagmentAll.Text',
      //   icon:'dot',
      //   routeLink: '/managment-report/target-report-managment-all',
      //   roles: ['SuperAdmin'],
      //   permissions: ['Report.Target']
      // },
      {
        label: 'MENUITEMS.ManagmentReports.atcTotalSell.Text',
        icon:'dot',
        routeLink: '/managment-report/atc-total-sell',
        roles: ['SuperAdmin'],
        permissions: []
      },


    ]
  },
  // Import Requests
  {
    label: 'MENUITEMS.ImportRequests.TEXT',
    icon:'shopping-bag',
    routeLink: '/import-requests/',
    roles: [],
    permissions: [
      'ImportRequest.View',
      'ImportRequest.Create',
    ],
    childs: [
      {
        label: 'MENUITEMS.ImportRequests.ViewImportRequest.TEXT',
        icon:'dot',
        routeLink: '/import-requests/view-import-requests',
        roles: [],
        permissions: ['ImportRequest.View']
      },
      {
        label: 'MENUITEMS.ImportRequests.CreateImportRequest.TEXT',
        icon:'dot',
        routeLink: '/import-requests/create-import-requests',
        roles: [],
        permissions: ['ImportRequest.Create']
      },

    ]
  },
  // Others
  {
    label: 'MENUITEMS.OTHER.TEXT',
    routeLink:'/other/',
    icon: 'circle-ellipsis',
    roles: ['SuperAdmin','Agent','Accountants'],
    permissions: [
      'Ticket.Create',
      'Invoice.Approval',
      'Invoice.Approval',
      'LikeCard.View',
      'OneCard.View'
    ],
    childs: [
      {
        label: 'MENUITEMS.OTHER.OTP.TEXT',
        icon:'dot',
        routeLink: '/other/get-otp',
        roles: ['SuperAdmin'],
        permissions: []
      },
      // {
      //   label: 'MENUITEMS.OTHER.Messages.TEXT',
      //   icon:'dot',
      //   routeLink: '/other/messages',
      //   roles: ['SuperAdmin','Agent'],
      //   permissions: []
      // },
      {
        label: 'MENUITEMS.OTHER.TicketsSettings.TEXT',
        icon:'dot',
        routeLink: '/other/ticket-settings',
        roles: ['SuperAdmin'],
        permissions: ['Ticket.Create']
      },
      {
        label: 'MENUITEMS.OTHER.DirectPurchase.TEXT',
        icon:'dot',
        routeLink: '/other/direct-purchase',
        roles: ['SuperAdmin'],
        permissions: ['Invoice.Approval']
      },
      {
        label: 'MENUITEMS.OTHER.LikeCardPurchase.TEXT',
        icon:'dot',
        routeLink: '/other/purchase-like-card',
        roles: ['SuperAdmin'],
        permissions: ['LikeCard.View']
      },
      {
        label: 'MENUITEMS.OTHER.OneCardPurchase.TEXT',
        icon:'dot',
        routeLink: '/other/purchase-one-card',
        roles: [],
        permissions: ['OneCard.View']
      },
    ]
  },
   // Compare Csv
   {
    label: 'MENUITEMS.CompareCSV.TEXT',
    icon: 'scan-eye',
    routeLink: '/compare-csv',
    roles: ['SuperAdmin'],
    permissions: []
  },

  {
    label: 'MENUITEMS.Settings.VisaTransactionLog.TEXT',
    icon: 'logs',
    routeLink: '/visa-transaction-log',
    roles: [],
    permissions: [
      "VisaTransactionLog.View",
    ]
  },

 
];